import angular from "angular";
import ServiceRA from "app/services/ServiceRA";
import dcModal from "modules/dc-ui/dc-modal";
import Utils from "./Utils";
import Events from "app/services/Events";
import LocaleService from "app/services/LocaleService.js";

export default angular.module("services.MessageService", [ServiceRA, dcModal, Utils, Events]).factory("MessageService",
  ["ServiceRA", "$q", "$log", "$rootScope", "$state", "Events", "DialogService", "Utils", "_", "LocaleService",
    function (ServiceRA, $q, $log, $rootScope, $state, Events, DialogService, Utils, _, LocaleService) {

      var collapsedFields = [];

      var regexpFields = ["title"];
      var dateFields = ["createdAtFrom", "createdAtUntil"];

      var fields = [
        {
          i18nKey: "common.columns.type",
          tooltipI18nKey: "messages.tooltip.message",
          type: "icon",
          iconClass: "fa fa-envelope-o",
          style: { width: "1%" },
          sortField: "type",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          dashboard: false,
          outbox: true
        },
        {
          i18nKey: "common.columns.title",
          field: (item) => this.getTitle(item),
          sortField: "title",
          type: "text",
          class: (item) => item.read ? "text-normal" : "text-bold",
          headerClass: "sort-align-right col-xs-8",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          onClick: (item) => this.gotoMessage(item._id),
          dashboard: true,
          outbox: true,
          filter: {
            type: "text", //[text | number | money | date ]
            field: "title",
            shouldShow: (key, value) => true
          }
        },
        {
          i18nKey: "common.columns.attachments",
          field: (item) => item.description,
          type: "text", // [text | number | money | date | custom]
          sortField: "description",
          class: "col-xs-1",
          headerClass: "sort-align-right text-center  col-xs-1",
          shouldShowColumn: (field) => false,
          shouldShow: (key, value) => false,
          dashboard: false,
          outbox: true
        },
        {
          i18nKey: "common.columns.read",
          field: (item) => item.read,
          type: "text",
          sortField: "read",
          class: (item) => item.read ? "text-normal" : "text-bold",
          onClick: (item) => this.toggleRead(item),
          style: { width: "1%" },
          shouldShowColumn: (field) => false,
          shouldShow: (key, value) => false,
          dashboard: false,
          outbox: false
        },
        {
          i18nKey: "common.columns.read",
          tooltipI18nKey: "messages.tooltip.toggleRead",
          //field: item => item.read,
          type: "icon",
          iconClass: (item) => item.read ? "fa fa-circle" : "fa fa-circle-o",
          sortField: "read",
          onClick: (item) => this.toggleRead(item),
          style: { width: "1%" },
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          dashboard: false,
          outbox: false
        },
        {
          i18nKey: "common.columns.received",
          field: item => item.createdAt,
          type: "date", // [text | number | money | date | custom]
          format: "shortDate",
          sortField: "createdAt",
          defaultSorting: "desc",
          //class: (item) => item.read ? "text-normal" : "text-bold",
          class: (item) => item.read ? "col-xs-1 text-normal" : "col-xs-1 text-bold",
          headerClass: "sort-align-right text-center col-xs-1",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          dashboard: true,
          outbox: true,
          filter: {
            type: "date", //[text | number | money | date | empty ]
            field: "createdAt",
            placeholderI18nKey: "filter.placeholder.date",
            rangeFilter: true,
            shouldShow: (key, value) => true
          }
        },
        {
          tooltipI18nKey: "messages.tooltip.deleteMessage",
          type: "icon",
          iconClass: "fa fa-trash-o",
          style: { width: "1%" },
          onClick: (item) => this.deleteMessage(item),
          refreshAfterClick: () => true,
          shouldShowItem: (field, item) => true,
          shouldShowColumn: (field) => true,
          dashboard: false,
          outbox: true
        }
      ];

      this.getTitle = (item) => {
        if (item.i18n && LocaleService.get(item.title)) {
          return LocaleService.get(item.title).replace(/<[^>]+>/gm, '');
        }
        else {
          
          return (item.title || "").replace(/<[^>]+>/gm, '');
        }
      };

      this.gotoMessage = (messageid) => {
        $state.go("messageDetails", {
          id: messageid
        });
      };

      this.toggleRead = (message) => {
        if (message.read) {
          this.markAsUnread(message);
        }
        else {
          this.markAsRead(message);
        }
      };

      this.markAsRead = (message) => {
        this.markMessage(message, "read");
      };

      this.markAsUnread = (message) => {
        this.markMessage(message, "unread");
      };

      this.markMessage = (message, type) => {
        markMessage(message, type);
      };

      var abortGet = $q.defer();

      function deleteMessage(message) {
        var defer = $q.defer();
        DialogService.showDialog(require("./templates/DeleteMessage.tpl.html"), ["$scope", "$uibModalInstance", "message", function ($scope, $uibModalInstance, message) {
          $scope.message = message;

          $scope.ok = function () {
            $uibModalInstance.close();
          };

          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        }], {
            message: function () {
              return message;
            }
          }).result.then(function () {
            if (message._id !== undefined && message._id !== null) {
              ServiceRA.one("messages", message._id).remove().then(function (response) {
                $rootScope.$emit(Events.MESSAGES_RELOAD);
                $state.go("messageInbox", {}, { reload: true });
                defer.resolve(response);
                //location.reload();
              }, function (err) {
                console.error("MS:", err);
                defer.reject(err);
              });
            }
          }, function () {
            //$log.info("cancel delete message");
          });
        return defer.promise;
      }

      this.deleteMessage = (message) => {
        deleteMessage(message);
      };

      function getContent(message) {
        var content = {
          title: message.title,
          text: message.text
        };
        if (message.i18n) {
          content.title = LocaleService.get(message.title);
          content.text = LocaleService.get(message.text);
        }
        return content;
      }

      function markMessage(message, type) {
        if (message._id !== undefined && message._id !== null) {
          message.read = !message.read;

          var m = ServiceRA.one("messages", message._id).one(type);
          var content = {
            localeLang: LocaleService.getCurrentLocale()
          };

          m.customPUT(content, null, null, null).then(function () {
            $rootScope.$emit(Events.MESSAGES_RELOAD);
          }, function (err) {
            console.error("MS:", err);
          });
        }
      }

      function skipMessage(message) {

        var defer = $q.defer();
        if (message && message._id) {
          var m = ServiceRA.one("messages", message._id).one("skipped");

          m.customPUT({}, null, null, null).then(function () {
            defer.resolve();
          }, function (err) {
            defer.reject(err);
          });
        }
        else {
          defer.resolve();
        }

        return defer.promise;
      }

      function markMessagebyID(msgid, type) {
        if (msgid !== undefined && msgid !== null) {
          /*message.read = !message.read;*/
          var m = ServiceRA.one("messages", msgid).one(type);

          m.put({}).then(function () {
            $rootScope.$emit(Events.MESSAGES_RELOAD);
          }, function (err) {
            console.error("MS:", err);
          });
        }
      }

      function getUnreadMessages(prevent) {
        return getMessages({
          filter: {
            read: false,
            max: "$max",
            sort: "-createdAt",
            preventExpirationExtention: prevent,
            isSpecialNotification: false
          }
        }, undefined, true);
      }

      function getMessages(_qo, action, preventAbort) {
        if (abortGet && !preventAbort) {
          abortGet.promise.isGloballyCanceled = true;
          abortGet.resolve();
        }
        abortGet = $q.defer();

        var qo = _qo || {
          filter: {}
        };
        qo.filter.skipped = false;

        qo = Utils.prepareFilter(qo, regexpFields, dateFields);

        if (qo.filter.page) {
          qo.filter.first = null;//(qo.filter.page * qo.filter.max);
        }

        var headers = Utils.prepareHeaders(action);
        return ServiceRA.all("messages").withHttpConfig({
          timeout: abortGet.promise
        }).getList(qo.filter, headers);
      }

      function getPopupMessages() {
        return getMessages({ "filter": { "showAsPopup": true, "read": false, "sort": "-createdAt" } }, "getInboxMessages", true);
      }

      function getMessage(msgid) {
        markMessagebyID(msgid, "read");
        return ServiceRA.one("messages", msgid).get();
      }

      /*function getAdminUser() {
       return ServiceRA.one("users", "admin").get();
       }*/

      function sendMessage(messagedata) {
        var headers = Utils.prepareHeaders("sendMessage");
        return ServiceRA.one("messages").post([], messagedata, null, headers);
      }

      function replyMessage(messagedata, msgid) {
        var headers = Utils.prepareHeaders("replyMessage");
        return ServiceRA.one("messages", msgid).one("reply").post([], messagedata, null, headers);
      }

      function getCollapsedFields(dashboard) {
        if (dashboard) {
          var copyFields = angular.copy(collapsedFields);
          return angular.copy(copyFields.filter(function (elem) {
            elem.sortField = "";
            return elem.dashboard === true;
          }));
        }
        else {
          return angular.copy(collapsedFields);
        }
      }

      function getFields(dashboard) {
        if (dashboard) {
          var copyFields = angular.copy(fields);
          return angular.copy(copyFields.filter(function (elem) {
            elem.sortField = "";
            return elem.dashboard === true;
          }));

        }
        else {
          return angular.copy(fields);
        }
      }

      function getOutFields(dashboard) {
        if (dashboard) {
          var copyFields = angular.copy(fields);
          return angular.copy(copyFields.filter(function (elem) {
            elem.sortField = "";
            return (elem.dashboard && elem.outbox) === true;
          }));
        }
        else {
          return angular.copy(fields.filter(function (elem) {
            return (elem.outbox) === true;
          }));
        }
      }

      function getStateParamMapping() {
        return {
          "title": "string",
          "createdAtFrom": "date",
          "createdAtUntil": "date",
          "download": "ignore",
          "downloadError": "ignore"
        };
      }

      return {
        getUnreadMessages: getUnreadMessages,
        getMessages: getMessages,
        getPopupMessages: getPopupMessages,
        markMessage: markMessage,
        markMessagebyID: markMessagebyID,
        getMessage: getMessage,
        //getAdminUser: getAdminUser,
        sendMessage: sendMessage,
        replyMessage: replyMessage,
        getCollapsedFields: getCollapsedFields,
        getFields: getFields,
        getOutFields: getOutFields,
        getStateParamMapping: getStateParamMapping,
        deleteMessage: deleteMessage,
        skipMessage: skipMessage
      };

    }]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/MessageService.js